<template>
  <div class="type-activity pb-8">
    <!-- header -->
    <div class="header-type d-flex flex-wrap justify-center justify-sm-space-between align-center">
        <div class="d-flex align-center mr-10">
           <div  class="keyboard-return" v-if="isMobile()">
            <v-btn
              elevation="0"
              icon
              color="white"
              @click="routePush('Lesson Detail', { id: lesson.lessonId })"
            >
              <v-icon>mdi-keyboard-return</v-icon>
            </v-btn>
          </div>


          <v-btn
            class="text-uppercase text-subtitle-2 white--text"
            color="#e97c21"
            elevation="0"
            plain
            @click="routePush('Lesson Detail', { id: lesson.lessonId })"
          >
            {{ lesson.title }}
          </v-btn>
          <v-icon class="text-subtitle-2 text-sm-subtitle-2  mr-3" color="white">mdi-chevron-right</v-icon>
          <span v-if="resource.activity" class="text-subtitle-2 text-sm-subtitle-2  text-uppercase">{{
            resource.activity.title
          }}</span>
        </div>
        <div class="d-flex align-center mr-5">
              <span class="text-subtitle-2 text-sm-subtitle-2 mr-5"  v-if="lesson.subject && !isMobile()" >{{ lesson.subject.name }}</span>
              <span class="text-subtitle-2 text-sm-subtitle-2 mr-5"  v-if="lesson.subject && isMobile()">{{ lesson.subject.abbreviation }}</span>
              <span class="text-subtitle-2 text-sm-subtitle-2" v-if="lesson.section">{{ lesson.section.nameAndCategoryName }}</span>
        </div>
    </div>

    <!-- header Mobile-->
    <!-- <div class="header-type d-sm-none">
      <v-row class="py-2" justify="center">
        <span
          class="text-uppercase body-2"
          @click="routePush('Lesson Detail', { id: lesson.lessonId })"
        >
          {{ lesson.title }}
        </span>
      </v-row>
      <v-row class="py-2" justify="center">
        <span class="text-uppercase body-2">
          {{ resource.activity.title }}
        </span>
      </v-row>
      <v-row class="py-2" justify="center">
        <span class="body-2" v-if="lesson.subject">{{ lesson.subject.name }} </span>
        <span class="body-2" v-if="lesson.section">
          - &nbsp;{{ lesson.section.nameAndCategoryName }}</span
        >
      </v-row>
    </div> -->
    <!-- content -->
    <div class="container-sources">
      <v-row justify="center" class="container-src-1">
        <v-col cols="12" 
        :lg="resource && resource.activity && resource.activity.instructive || resource.activity.isTask ?8:12" 
        class="container-src-2">
          <RomaText :resource="resource" v-if="$route.params.type === 'text'" />
          <RomaVideo
            class="roma-video"
            :resource="resource"
            v-if="$route.params.type === 'video'"
          />
          <RomaFile 
            class="roma-file"
          :resource="resource" v-if="$route.params.type === 'file'" />
          <RomaEmbeddedLink
            :resource="resource"
            v-if="$route.params.type === 'link-embebido'"
          />
          <RomaLink
            :resource="resource"
            v-if="$route.params.type === 'link-externo'"
          />
        </v-col>

        <v-col
          v-if="resource.activity.instructive.length || resource.activity.isTask"
          lg="4"
          class="instructions pr-0 pr-sm-10 mt-3"
        >
          <!-- Instructions -->
            <v-row  align="center" justify="center">
              <v-container class="instructions-container">
              <v-col cols="12" v-if="resource.activity.instructive">
                <v-card-text>
                  <h4 class="text-center font-weight-bold">Instrucciones</h4>
                </v-card-text>

                <v-row align="center" justify="center">
                  <quillEditor
                    class="rich-text-wrapper__editor"
                    :content="resource.activity.instructive"
                    :options="editorOption"
                    :disabled="true"
                  />
                </v-row>
              </v-col>

              <v-col
                cols="12"
                v-if="resource.activity.isTask && !activity.taskSubmitted"
              >
                <v-row>
                  <v-card-text>
                    <h4 class="text-center font-weight-bold">Enviar Tarea</h4>
                  </v-card-text>

                  <v-col cols="12">
                    <div class=" px-2">
                      <TipTap :data="setDescriptionTask" :updateMode="{ readOnly: false,modules: {toolbar: true},placeholder: ''}" />
                    </div>
                  </v-col>
                </v-row>

                <v-row class=" px-2">
                  <v-col>
                    <v-file-input
                      placeholder="Subir Archivos"
                      outlined
                      dense
                      chips
                      counter
                      multiple
                      show-size
                      truncate-length="15"
                      v-model="filesTask"
                    ></v-file-input>
                  </v-col>
                  <v-col>
                    <v-btn
                      block
                      elevation="4"
                      rounded
                      :disabled="!(filesTask.length>0 || this.descriptionTask)"
                      color="primary"
                      @click="createOrUpdate()"
                      >Enviar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                cols="12"
                v-else-if="activity.taskSubmitted && activity.taskDetails!==undefined && activity.taskDetails.state === 1"
              >

                <v-row>
                  <v-card-text v-if="activity.taskDetails.score && activity.taskDetails.score>0 && !activity.taskDetails.achievement">
                    <h4 class="text-center font-weight-bold">TAREA EVALUADA  {{activity.taskDetails.score}} <v-icon color="green" large>mdi-check</v-icon></h4>
                  </v-card-text>
                  <v-card-text v-else-if="activity.taskDetails.achievement && activity.taskDetails.achievement>0 && !activity.taskDetails.score">
                    <h4 class="text-center font-weight-bold">TAREA EVALUADA  {{activity.taskDetails.achievement}}% <v-icon color="green" large>mdi-check</v-icon></h4>
                  </v-card-text>
                  <v-card-text v-else-if="activity.taskDetails.achievement && activity.taskDetails.achievement>0 && activity.taskDetails.score && activity.taskDetails.score>0">
                    <h4 class="text-center font-weight-bold">TAREA EVALUADA  {{activity.taskDetails.score}} / {{activity.taskDetails.achievement}}% <v-icon color="green" large>mdi-check</v-icon></h4>
                  </v-card-text>

                  <v-col cols="12">

                    <h5 class="text-left font-weight-bold px-2">
                      Respuesta del alumno
                    </h5>

                    <div class=" px-2">
                      <quillEditor
                          class="lesson-detail__quill"
                          :content="activity.taskDetails.taskDescription"
                          :options="editorOption2"
                          :disabled="true"
                      />
                  </div>

                   <v-row>
                   <v-col>
                    <template v-for="(file, i) in activity.taskDetails.taskFileList">
                      <v-chip
                        :key="i"
                        v-if="file.proprietary == 'STUDENT'"
                        class="ma-2"
                        link
                        target="_blank"
                        :href="`${link}${file.taskFileId}`"
                        color="orange"
                        text-color="white"
                      >
                        <v-avatar left>
                          <v-icon>mdi-download</v-icon>
                        </v-avatar>
                        {{ file.fileName }}
                      </v-chip>
                    </template>
                  </v-col>
                  </v-row>

                  </v-col>

                  <v-col cols="12" v-if="activity.taskDetails.feedback">

                    <h5 class="text-left font-weight-bold px-2">
                      Retroalimentación
                    </h5>
                    <div class=" px-2">
                      <quillEditor
                          class="lesson-detail__quill"
                          :content="activity.taskDetails.feedback"
                          :options="editorOption2"
                          :disabled="true"
                      />
                    </div>

                   <v-row>
                   <v-col>
                    <template v-for="(file, i) in activity.taskDetails.taskFileList">
                      <v-chip
                        :key="i"
                        v-if="file.proprietary == 'TEACHER'"
                        class="ma-2"
                        link
                        target="_blank"
                        :href="`${link}${file.taskFileId}`"
                        color="orange"
                        text-color="white"
                      >
                        <v-avatar left>
                          <v-icon>mdi-download</v-icon>
                        </v-avatar>
                        {{ file.fileName }}
                      </v-chip>
                    </template>
                  </v-col>
                  </v-row>



                  </v-col>
                </v-row>

              </v-col>

              <v-col cols="12" v-else-if="activity.taskSubmitted && activity.taskDetails!==undefined && activity.taskDetails.state === 0">
                <v-row>
                  <v-card-text>
                    <h4 class="text-center">
                      <v-icon color="green" large>mdi-check</v-icon>
                    </h4>
                    <h4 class="text-center font-weight-bold">
                      TAREA ENVIADA
                    </h4>

                    <v-col cols="12" v-if="activity.taskDetails.taskDescription">
                      <div class=" px-2">
                        <quillEditor
                            class="lesson-detail__quill"
                            :content="activity.taskDetails.taskDescription"
                            :options="editorOption2"
                            :disabled="true"
                        />
                      </div>
                    </v-col>

                  </v-card-text>
                </v-row>
              </v-col>

              <v-col cols="12" v-else-if="activity.taskSubmitted == true">
                <v-row>
                  <v-card-text>
                    <h4 class="text-center">
                      <v-icon color="green" large>mdi-check</v-icon>
                    </h4>
                    <h4 class="text-center font-weight-bold">
                      TAREA ENVIADA
                    </h4>

                  </v-card-text>
                </v-row>
              </v-col>
              </v-container>
            </v-row>
        </v-col>
      </v-row>
    </div>

    <!-- footer -->

      <div
        class="pagination-resources d-flex flex-wrap justify-center"
        :style="{ left: 'auto', right: 'auto' }"
      >

         <div  class="keyboard-return" v-if="!isMobile()">
            <v-btn
              elevation="0"
              large
              icon
              class="btn-expand"
              @click="routePush('Lesson Detail', { id: lesson.lessonId })"
            >
              <v-icon>mdi-keyboard-return</v-icon>
            </v-btn>
          </div>


          <div class="d-flex flex-wrap align-center justify-center"> 
            <v-btn
                plain
                elevation="0"
                class="btn-arrow"
                v-if="!previousPagination()"
                @click="previous()"
                disabled
                large
                
            >
                <v-icon>mdi-chevron-left</v-icon> Anterior</v-btn
            >
            <v-btn
              elevation="0"
              large
              color="white"
              class="btn-arrow"
              v-if="previousPagination()"
              @click="previous()"
            >
              <v-icon>mdi-chevron-left</v-icon> Anterior</v-btn
            >

            <p class="d-inline mx-4">
              {{ this.resourceIndex + 1 }} / {{ this.resources.length }}
            </p>

            <v-btn
              elevation="0"
              large
              color="white"
              class="btn-arrow"
              v-if="nextPagination()"
              @click="next()"
              >Siguiente <v-icon>mdi-chevron-right</v-icon></v-btn
            >
            <v-btn
              elevation="0"
              large
              color="white"
              class="btn-arrow"
              v-if="!nextPagination()"
              @click="next()"
              disabled
              >Siguiente <v-icon>mdi-chevron-right</v-icon></v-btn
            >

            <v-btn
              class="mx-2  white--text"
              fab
              small
              color="primary"
              v-if="downloadable && $route.params.type === 'file'"
              :href="downloadable"
              target="_blank"
            >
              <v-icon dark> mdi-download </v-icon>
            </v-btn>
         </div>
      </div>

    <!-- <v-row align="center" justify="center">
      <v-card
        class="pagination-resources footer-mobile"
        :style="{ left: 'auto', right: 'auto' }"
      >
        <v-btn
          icon
          class="btn-expand"
          @click="routePush('Lesson Detail', { id: lesson.lessonId })"
        >
          <v-icon>mdi-keyboard-return</v-icon>
        </v-btn>

        <v-btn
          color="white"
          class="btn-arrow"
          v-if="previousPagination()"
          @click="previous()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <p class="d-inline mx-1">
          {{ this.resourceIndex + 1 }} / {{ this.resources.length }}
        </p>

        <v-btn
          color="white"
          class="btn-arrow"
          v-if="nextPagination()"
          @click="next()"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <div class="mb-1 d-flex justify-center" v-if="downloadable && $route.params.type === 'file'">
          <v-btn
            class="mx-2 amber darken-4 white--text"
            fab
            small
            :href="downloadable"
            target="_blank"
          >
            <v-icon dark> mdi-download </v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-row> -->
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import TipTap from "@/components/commons/RomaTipTap";

import RomaText from "@/components/class/RomaText";
import RomaVideo from "@/components/class/RomaVideo";
import RomaFile from "@/components/class/RomaFile";
import RomaEmbeddedLink from "@/components/class/RomaEmbeddedLink";
import RomaLink from "@/components/class/RomaLink";

import { mapActions, mapGetters } from "vuex";

// MIXINS
import Utility from "@/mixins/Utility";

export default {
  name: "TypeActivity",
  components: {
    RomaText,
    RomaVideo,
    RomaFile,
    RomaEmbeddedLink,
    RomaLink,
    quillEditor,
    TipTap
  },
  mixins: [Utility],
  data() {
    return {
      expand: true,
      activityId: this.$route.params.id,
      editorOption: {
        readOnly: true,
        modules: {
          toolbar: false
        },
        placeholder: ''
      },
      editorOption2: {
        readOnly: true,
        modules: {
          toolbar: true
        },
        placeholder: ''
      },
      descriptionTask: "",
      filesTask: []
    };
  },
  computed: {
    ...mapGetters({
      // getResource: "getResource",
      lesson: "getLesson",
      activity: "getCurrentActivity",
      resource: "getCurrentResource",
      resources: "getCurrentResources",
      resourceIndex: "getResourcePaginationIndex"
    }),
    downloadable() {
      return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/${this.resource.resourcesId}`;
    },
    link() {
      return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/task/`;
    }
  },
  mounted() {
    this.actionClickOnResource({
      resourceId: this.resource.resourcesId,
      activityId: this.resource.activity.activityLessonId
    });
  },
  destroyed() {
    this.actionResetCurrentResource();
    this.actionResetCurrentActivity();
  },
  watch: {
    resource(newVal) {
      this.actionClickOnResource({
        resourceId: newVal.resourcesId,
        activityId: newVal.activity.activityLessonId
      });
    }
  },
  methods: {
    ...mapActions({
      toastSuccess: "toastSuccess",
      actionSetCurrentResource: "actionSetCurrentResource",
      actionSetResourcePaginationIndex: "actionSetResourcePaginationIndex",
      actionResetCurrentActivity: "actionResetCurrentActivity",
      actionResetCurrentResource: "actionResetCurrentResource",
      actionClickOnResource: "actionClickOnResource",
      getResourceById: "getResourceById",
      actionSendTask: "actionSendTask",
      actionSetCurrentActivity: "actionSetCurrentActivity"
    }),
    leftPagination() {
      const typeResource = this.$route.params.type;
      if (typeResource === "text") {
        return "45%";
      } else if (typeResource === "video") {
        return "35%";
      } else if (typeResource === "pdf") {
        return "45%";
      }
    },
    widthPagination() {
      const typeResource = this.$route.params.type;
      if (typeResource === "text") {
        return "28%";
      } else if (typeResource === "video") {
        return "28%";
      } else if (typeResource === "pdf") {
        return "28%";
      }
    },
    previousPagination() {
      // const typeResource = this.$route.params.type;
      // if (typeResource === "pdf") {
      //   return true;
      // } else return typeResource === "video";

      return this.resourceIndex == 0 ? false : true;
    },
    nextPagination() {
      return this.resources.length - (this.resourceIndex + 1) > 0
        ? true
        : false;
    },
    previous() {
      const previousResource = this.resources[this.resourceIndex - 1];
      this.actionSetResourcePaginationIndex(this.resourceIndex - 1);
      this.actionSetCurrentResource(previousResource);
      this.actionSetCurrentActivity(previousResource.activity);
      this.filesTask = [];

      this.$router.push({
        name: "ActivityType",
        params: {
          id: previousResource.resourcesId,
          type: this.getUrlActivity(previousResource.resourceType.type)
        }
      });
      console.log("Atras");
    },
    next() {
      const nextResource = this.resources[this.resourceIndex + 1];
      this.actionSetResourcePaginationIndex(this.resourceIndex + 1);
      this.actionSetCurrentResource(nextResource);
      this.actionSetCurrentActivity(nextResource.activity);
      this.filesTask = [];

      this.$router.push({
        name: "ActivityType",
        params: {
          id: nextResource.resourcesId,
          type: this.getUrlActivity(nextResource.resourceType.type)
        }
      });
      console.log("Siguiente");
    },
    setDescriptionTask(description) {
      this.descriptionTask = description;
    },
    createOrUpdate() {
      //only send
      this.sendTask();
    },
    sendTask() {
      const form = new FormData();

      form.append("activityId", this.resource.activity.activityLessonId);
      form.append("description", this.descriptionTask);

      this.filesTask.forEach((element, i) => {
        form.append("files", this.filesTask[i]);
      });

      console.log("### ENVIAR TAREA ###");
      for (const pair of form.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      this.actionSendTask(form)
        .then(() => {
          this.toastSuccess({
            title: `Exito!`,
            message: `Se ha enviado la tarea`
          });

          this.activity.taskSubmitted = true;
          this.activity.taskDetails = {state: 2};
          this.actionSetCurrentActivity(this.activity);

          // this.goBack();
        })
        .catch(err => {
          console.info("error", err);
        });
    },
     isMobile(){
        const widthScreen = window.innerWidth;
        return widthScreen < 540 ? true: false;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 0 !important;
}

.type-activity {
    height: 100%;

  .header-type {
    // height: 56px;
    padding: 0 15px;
    line-height: 34px;
    background: #e97c21 0 0 no-repeat padding-box;
    box-shadow: 0 3px 6px #0000001c;
    span {
      font-size: 20px;
      font-family: "Cabin", Regular !important;
      color: map-get($colors, "white");
    }
    .subject {
      font-size: 18px;
    }
    .grade {
      margin-left: 10px;
      border-radius: 50px;
      padding: 8px 2px;
      margin-right: 15px;
      width: 35px;
      height: 35px;
      line-height: 14px;
      background: #d56d16 0 0 no-repeat padding-box;
      text-align: center;
      font-size: 17px;
      font-family: "Cabin", Regular !important;
      letter-spacing: 0;
      color: #ffffff;
    }
    .btn-back {
      text-align: left;
      font-size: 20px;
      font-family: "Cabin", Regular !important;
      letter-spacing: 0;
      color: #e97c21;
    }
  }
  .container-sources {
    // padding: 20px;
      position: relative;
      height: 100%;
    .container-src-1{
      height: 100%;
      .container-src-2{
          // height: 100%;  
         padding-right: 20px;
         padding-left: 20px;
        .roma-text{
          height: 100%;
          }
        .roma-link{
          height: 100%;
          }
        .roma-video{
            margin: 10px;
         }
         .roma-file{
            margin: 10px;

         }
      }
    }
  }

  .pagination-resources {
    z-index: 5;
    border-radius: 10px;
    position: sticky;
    bottom: 5px;
    margin-left: auto;
    margin-right: auto; 
    background: white 0 0 no-repeat padding-box;
    box-shadow: 0 6px 10px #0000003b;
    max-width: 450px;
    // padding: 0 20px;
    .btn-arrow {
      // margin: 10px 15px;
      // height: 56px;
      // width: 150px;
      background: #ffffff 0 0 no-repeat padding-box;
      box-shadow: 0 6px 15px #00000029;
      border-radius: 33px;
      opacity: 1;
      color: #590564;
      text-transform: capitalize;
      font: Medium 18px/22px Cabin;
    }
    .btn-expand {
      // margin: 5px 25px 5px 30px;
      height: 56px;
      width: 65px;
      background: #ffffff 0 0 no-repeat padding-box;
      box-shadow: 0 6px 15px #00000029;
      border-radius: 100px;
      opacity: 1;
      color: #590564;
      text-transform: capitalize;
      font: Medium 18px/22px Cabin;
    }
  }
  .roma-icon-back:before {
    content: url("../../assets/icons/back.svg");
  }
}

.instructions-container {
  background: #ffffff;
  // margin-bottom: 100px;
  word-break: normal;
  padding: 2rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.pagination-resources.footer-mobile {
  .btn-arrow {
    margin: 10px 0px;
    height: 50px;
    width: 50px;
    background: #ffffff 0 0 no-repeat padding-box;
    box-shadow: 0 6px 15px #00000029;
    border-radius: 33px;
    opacity: 1;
    color: #590564;
    text-transform: capitalize;
    font: Medium 18px/22px Cabin;
  }
  .btn-expand {
    margin: 5px 10px 5px 5px;
    height: 50px;
    width: 50px;
    background: #ffffff 0 0 no-repeat padding-box;
    box-shadow: 0 6px 15px #00000029;
    border-radius: 100px;
    opacity: 1;
    color: #590564;
    text-transform: capitalize;
    font: Medium 18px/22px Cabin;
  }
}

.rich-text-wrapper{
    &__editor{
        width: 100%;
    }
}

// @media (max-width: 380px) {
//     .type-activity{
//         position: relative;
//         .pagination-resources{
//             position: sticky;
//             .keyboard-return{
//                 position: absolute;
//                 top: 40px;
//                 left: 0;
//                 .btn-expand {
//                     // margin: 0px 25px 0px 10px;
//                     height: 30px;
//                     width: 45px;
//                 }
//             }
//         }
//     }
// }
</style>
